export function isWindowsDrivePath(value) {
    return /^[a-zA-Z]:([/\\]|$)/.test(value);
}
export function isUncPath(value) {
    return value.startsWith("\\\\");
}
